import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CommunicationsDataTable from '../CommunicationsDataTable';
import { clearHistoryNotificationFilters, filterHistoryNotifications, updateHistoryNotificationFinalDateFilter, updateHistoryNotificationFinalTimeFilter, updateHistoryNotificationInitialDateFilter, updateHistoryNotificationInitialTimeFilter, updateHistoryNotificationSearchValue } from '../../../reducers/CommunicationsReducer';
import CommunicationsCalendarModal from '../CommunicationsCalendarModal';
import CommunicationsDownloadModal from '../CommunicationsDownloadModal';
import { NOTIFICATION_HEADERS } from '../HeaderHelper';

const HistoryDataTable = (props) => {
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  useEffect(() => {
    let initialFilterData, finalFilterData, hours, minutes;

    if (props.historyInitialDateFilter) {
      initialFilterData = new Date(props.historyInitialDateFilter);

      if (props.historyInitialTimeFilter) {
        hours = props.historyInitialTimeFilter.split(':')[0];
        minutes = props.historyInitialTimeFilter.split(':')[1];

        initialFilterData.setHours(hours, minutes);
      }
    }

    if (props.historyFinalDateFilter) {
      finalFilterData = new Date(props.historyFinalDateFilter);

      if (props.historyFinalTimeFilter) {
        hours = props.historyFinalTimeFilter.split(':')[0];
        minutes = props.historyFinalTimeFilter.split(':')[1];

        finalFilterData.setHours(hours, minutes);
      }
    }

    props.filterHistoryNotifications({
      initialFilterData: initialFilterData,
      finalFilterData: finalFilterData
    });
  }, [props.historyInitialDateFilter, props.historyInitialTimeFilter, props.historyFinalDateFilter, props.historyFinalTimeFilter]);

  return (
    <React.Fragment>
      <CommunicationsDataTable
        isNotificationData={true}
        displayCommunications={props.displayHistoryNotifications}
        filteredCommunications={props.filteredHistoryNotifications}
        headers={NOTIFICATION_HEADERS}
        isMobile={props.isMobile}
        isHistory={true}
        isDownloadModalOpen={isDownloadModalOpen}
        setIsDownloadModalOpen={setIsDownloadModalOpen}
        initialDateFilter={props.historyInitialDateFilter}
        initialTimeFilter={props.historyInitialTimeFilter}
        finalDateFilter={props.historyFinalDateFilter}
        finalTimeFilter={props.historyFinalTimeFilter}
        updateInitialDateFilter={props.updateHistoryNotificationInitialDateFilter}
        updateInitialTimeFilter={props.updateHistoryNotificationInitialTimeFilter}
        updateFinalDateFilter={props.updateHistoryNotificationFinalDateFilter}
        updateFinalTimeFilter={props.updateHistoryNotificationFinalTimeFilter}
        clearFilters={props.clearHistoryNotificationFilters}
        searchValue={props.historySearchValue}
        updateCommunicationSearchValue={props.updateHistoryNotificationSearchValue}
        loadCommunicationStatus={props.loadNotificationStatus} />
      <CommunicationsCalendarModal
        displayCommunications={props.displayHistoryNotifications}
        filterCommunications={props.filterHistoryNotifications} />
      <CommunicationsDownloadModal
        isNotificationData={true}
        data={props.displayHistoryNotifications} />
    </React.Fragment>
  )
}

export default connect(
  (state) => ({
    displayHistoryNotifications: state.communications.displayHistoryNotifications,
    filteredHistoryNotifications: state.communications.filteredHistoryNotifications,
    historyPageNumber: state.communications.historyPageNumber,
    historyPageSize: state.communications.historyPageSize,
    historyFilterAreaOpened: state.communications.historyFilterAreaOpened,
    historyInitialDateFilter: state.communications.historyInitialDateFilter,
    historyInitialTimeFilter: state.communications.historyInitialTimeFilter,
    historyFinalDateFilter: state.communications.historyFinalDateFilter,
    historyFinalTimeFilter: state.communications.historyFinalTimeFilter,
    historySearchValue: state.communications.historySearchValue,
    loadNotificationStatus: state.communications.loadNotificationStatus
  }), {
  clearHistoryNotificationFilters,
  filterHistoryNotifications,
  updateHistoryNotificationSearchValue,
  updateHistoryNotificationInitialDateFilter,
  updateHistoryNotificationInitialTimeFilter,
  updateHistoryNotificationFinalDateFilter,
  updateHistoryNotificationFinalTimeFilter
}
)(HistoryDataTable);